import type { Hero, HeroSeatSlot, TableEdge } from "../types";

/** A standard hero occupies exactly one map grid cell unless the DM enlarges it. */
export const DEFAULT_HERO_RING_SCALE = 1;
export const MIN_HERO_RING_SCALE = 1;
export const MAX_HERO_RING_SCALE = 2.5;
export const DEFAULT_HERO_SEAT_EDGE: TableEdge = "south";
export const DEFAULT_HERO_SEAT_SLOT: HeroSeatSlot = "center";

export function clampHeroRingScale(value?: number): number {
  if (!Number.isFinite(value)) return DEFAULT_HERO_RING_SCALE;
  return Math.max(MIN_HERO_RING_SCALE, Math.min(MAX_HERO_RING_SCALE, value!));
}

export function heroSeatEdge(hero: Pick<Hero, "seatEdge">): TableEdge {
  return hero.seatEdge ?? DEFAULT_HERO_SEAT_EDGE;
}

export function heroSeatSlot(hero: Pick<Hero, "seatSlot">): HeroSeatSlot {
  return hero.seatSlot ?? DEFAULT_HERO_SEAT_SLOT;
}

/** Rotation for a future character panel, facing the player seated at this edge. */
export function heroPanelRotation(edge: TableEdge): 0 | 90 | 180 | 270 {
  if (edge === "north") return 180;
  if (edge === "east") return 270;
  if (edge === "west") return 90;
  return 0;
}
